import { Trans } from '@lingui/macro'
import { RouteConfig } from 'app/router/Routes'
import { EgretLoadable } from 'egret'
import { authRoles } from '../../auth/authRoles'
import { SAT_PATHS } from './SATConstants'

const SATLanding = EgretLoadable({
  loader: async () => await import('./CompassLanding')
})

const MyAssessments = EgretLoadable({
  loader: async () => await import('./CompassAssessments')
})

const satRoutes: RouteConfig[] = [
  {
    path: SAT_PATHS.SAT_LANDING,
    component: SATLanding,
    isTranslatable: true,
    auth: authRoles.grantee,
    label: <Trans>NAVIGATIONS_ORGANIZATIONAL_COMPASS</Trans>
  },
  {
    path: SAT_PATHS.MY_ASSESSMENTS,
    component: MyAssessments,
    isTranslatable: true,
    auth: authRoles.grantee,
    label: <Trans>NAVIGATIONS_ASSESSMENTS</Trans>,
    showCollapseBtn: true
  },
  {
    path: '/surveys/SurveyTab/:id/:surveyId/:mode',
    component: EgretLoadable({
      loader: async () => await import('../surveys/SurveyTab')
    }),
    auth: authRoles.grantee,
    showCollapseBtn: true,
    collapseByDefault: true,
    errorRedirectPath: SAT_PATHS.MY_ASSESSMENTS
  }
]

export default satRoutes
